<template>
  <div>
    <multiselect
        :key="`${_uid}-product-services`"
        :name="name || 'shrimp_id'"
        :placeholder="placeholder || $t('Select {something}', { something: $t('shrimps.singular') })"
        :value="selectedValue"
        @input="(v) => onInput(v)"
        @update:selected="$emit('update:selected', $event)"
        :custom-label="customLabel"
        :required="required"
        :disabled="disabled"
        :params="{ ...params }"
        :open-direction="openDirection"
        :multiple="multiple"
        :options="options"
        :show-labels="false"
    >
      <template v-slot:option="{ option }">
        <slot name="option" v-bind="{ option }"></slot>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
export default {
  name: "sub-product-multiselect",
  components: {
    Multiselect,
  },
  props: {
    options: {
      type: Array,
      default: () => [
        'hybrid',
        'deposit_goods',
        'harvest',
        'cash',
      ],
    },
    name: {
      type: String,
      default: undefined
    },
    placeholder: {
      type: String,
      default: undefined
    },
    value: {
      type: Array,
      default: null
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: function () {
        return { sort: 'id,desc' }
      }
    },
    initialValue: {
      type: Object,
      default() {
        return {};
      }
    },
    openDirection: {
      type: String,
      default: undefined
    },
    multiple: {
      type: Boolean,
      default: true,
    }
  },
  methods: {
    onInput(event) {
      this.$emit('input', event.filter((v) => this.options.includes(v)) || undefined)
    },
    clearAll() {
      this.$emit('input', undefined)
    },
    customLabel(option) {
      return this.$t(`shrimps.products_dropdown.${option}`)
    }
  },
  data(){
    return {
      selectedValue: undefined,
    }
  },
  watch:{
    value: {
      immediate: true,
      handler: function (val) {
        if(val){
          this.selectedValue = val.filter((v) => this.options.includes(v)) || undefined;
        }else {
          this.selectedValue = undefined;
        }
      },
    }
  }
}
</script>

<style scoped>

</style>
